/* BBE Bureau Night Shift — theme.js (vanilla) */
(function () {
  // Mobile nav toggle (mockup hides tabs <860px; this exposes them)
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-tabs]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product page: swap main image when a thumb is clicked
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function (e) {
      e.preventDefault();
      var main = document.querySelector('[data-main-image]');
      if (main) { main.src = thumb.getAttribute('data-full'); }
    });
  });

  // Product page: variant select updates price + form id + availability
  var variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      var priceEl = document.querySelector('[data-price]');
      var btn = document.querySelector('[data-add-btn]');
      if (priceEl && opt.getAttribute('data-price')) {
        priceEl.textContent = opt.getAttribute('data-price');
      }
      if (btn) {
        if (opt.getAttribute('data-available') === 'false') {
          btn.setAttribute('disabled', 'disabled');
          btn.textContent = btn.getAttribute('data-soldout-text');
        } else {
          btn.removeAttribute('disabled');
          btn.textContent = btn.getAttribute('data-add-text');
        }
      }
    });
  }
})();
